import React from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { FieldSet, Spinner } from '../elements';
import { Documents } from '../components';
import { API_URL } from '../../lib/const';
import {
  PAYMENT_STATUS,
  PAYMENT_METHOD,
  ENROLLMENT_STATUS,
} from '../../lib/config';
import ComponentWithToken from '../components/CompontentWithToken';
import DownloadButton from '../components/DownloadButton';
import {
  fetchFinanceDataSummary,
  regenerateOverdueBoleto,
} from '../services/finance_data_service';
import LogoS2P from '../../assets/img/logo_s2p.png';
import CreditCardPaymentForm from './CreditCardPaymentForm';
import { ButtonStyle } from '../../assets/css/components/ButtonStyle';
import { getCardFlag } from '../../lib/utils';
import ListStudentBoleto from '../components/boleto/ListStudentBoleto';

class Payment extends ComponentWithToken {
  state = {
    loading: false,
    status: null,
    invoices: [],
    proofs_of_payment: [],
    boleto_id: null,
    onboardingPaymentMethods: [],
    ProofSent: true,
    complementaryBoletos: [],
    financePlan: {},
    planValue: 0,
    creditCardValue: 0,
    installments: 1,
    gratuity: null,
    redirectUrl: null,
    gratuity: null,
  };

  componentDidMount() {
    Promise.all([
      this.fetchStatus(),
      this.fetchFinanceData(),
      this.fetComplementaryBoletos(),
    ]).finally(this.setState({ loading: false }));
  }

  fetComplementaryBoletos = () => {
    axios
      .get(`${API_URL}/onboarding/complementary-boletos/${this.token}`)
      .then((response) =>
        this.setState({ complementaryBoletos: response.data })
      );
  };

  fetchStatus() {
    this.setState({ loading: true });
    return axios
      .get(`${API_URL}/onboarding/enroll/${this.token}`)
      .then((response) =>
        this.setState({
          status: get(response, 'data.enrollment_status'),
          envelopeStatus: get(response, 'data.envelope_status'),
          showProof: get(response, 'data.show_proof'),
          ProofSent: get(response, 'data.proof_sent'),
          gratuity: get(response, 'data.gratuity'),
        })
      );
  }

  fetchFinanceData = () =>
    fetchFinanceDataSummary(this.token).then((response) =>
      this.setState({
        financePlan: get(response, 'plan'),
        boleto_id: get(response, 'boleto_id'),
        planValue: get(response, 'plan_value'),
        creditCardValue: get(response, 'credit_card_value'),
        onboardingPaymentMethods: get(response, 'onboarding_payment_methods'),
        transactionStatus: get(response, 'transaction_status'),
        installments: get(response, 'credit_card_installments'),
      })
    );

  handleDocumentUpload = (event) => {
    const file = get(event, 'target.files.0');
    const data = new FormData();
    data.append('file', file);
    data.append('document_type', 6);
    return axios
      .post(`${API_URL}/uploads/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        this.setState((prevState) => {
          const { proofs_of_payment } = prevState;
          proofs_of_payment.push({ key: response.data.key, name: file.name });
          return { proofs_of_payment };
        });
      });
  };

  handleProofOfPaymentRemove = (key) => {
    const { proofs_of_payment } = this.state;
    const new_proofs_of_payment = proofs_of_payment.filter(
      (proof) => proof.key !== key
    );
    this.setState({ proofs_of_payment: new_proofs_of_payment });
  };

  handleSend() {
    const { proofs_of_payment } = this.state;
    const { token } = this.props;
    this.setState({ loading: true });
    const data = {
      proofs_of_payment,
    };

    axios
      .post(`${API_URL}/onboarding/proof-of-payment/${token}`, data)
      .then(() => {
        toast.success('Comprovante de pagamento enviado', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        this.componentDidMount();
      })
      .catch((error) => {
        toast.error(
          get(error, 'response.data[0]', 'Ocorreu um erro inesperado'),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
        this.setState({
          loading: false,
        });
      });
  }

  renderComprovantePagamento() {
    const { proofs_of_payment } = this.state;
    return (
      <>
        <div
          className="documents-base row"
          style={{ justifyContent: 'flex-start' }}
        >
          <Documents
            id="Comprovante de pagamento"
            label="Comprovante de pagamento"
            onUpload={this.handleDocumentUpload}
            onRemove={this.handleProofOfPaymentRemove}
            documents={proofs_of_payment}
          />
        </div>
        <ButtonStyle
          className="mt-2"
          onClick={() => this.handleSend()}
          type="button"
        >
          ENVIAR
        </ButtonStyle>
        <hr />
      </>
    );
  }

  renderDownloadContract() {
    return (
      <>
        <FieldSet title="Contrato" />
        <DownloadButton
          href={`${API_URL}/contracts/enrollment/${this.token}/contract`}
          label="Baixar contrato"
        />
        <div className="row mb-3 mt-3">
          <div className="col-sm-12 mt-3">
            <label>
              Para assinar o contrato digitalmente busque no seu provedor de
              e-mail pelo contrato enviado pela DocuSign.
            </label>
          </div>
        </div>
      </>
    );
  }

  generateBoleto = () => {
    regenerateOverdueBoleto(this.token).then((d) => {
      this.setState({ boleto_id: d.boleto_id });
      toast.success('Boleto gerado com sucesso!');
    });
  };

  generateSafeToPay = (token) => {
    axios
      .post(`${API_URL}/finance/safe_to_pay/${token}`)
      .then((response) => {
        const url = response.data.ResponseDetail.SingleSaleUrl;
        this.setState({ redirectUrl: url });
        window.open(url);
      })
      .catch((err) => toast.error(err.response.data.error));
  };

  renderSafeToPayPaymentSection() {
    return (
      <>
        <FieldSet title="Pagamento" />
        <div
          className="d-flex flex-columns w-50"
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <img
            src={LogoS2P}
            style={{
              width: '35%',
              height: '35%',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              marginTop: '8px',
              marginBottom: '16px',
              alignSelf: 'center',
            }}
          />
          <ButtonStyle
            onClick={() => this.generateSafeToPay(this.token)}
            className="mt-2 bg-cyan-500 hover:bg-cyan-600 text-white"
          >
            Redirecionar para pagamento
          </ButtonStyle>
          <hr />
        </div>
      </>
    );
  }

  renderBoletoPaymentSection() {
    const { boleto_id, complementaryBoletos, financePlan, gratuity } =
      this.state;
    const { user_can_generate_boleto } = financePlan;
    return (
      <ListStudentBoleto
        boleto={boleto_id}
        complementaryBoletos={complementaryBoletos}
        userCanGenerateBoletos={user_can_generate_boleto}
        onResubmit={this.generateBoleto}
        gratuity={gratuity}
      />
    );
  }

  isEnrollmentPaid = () => {
    const { transactionStatus, ProofSent } = this.state;
    const transactionStatusId = get(transactionStatus, 'id');
    return !!(
      (transactionStatusId === PAYMENT_STATUS.PAYMENT_CONFIRMED) |
      ProofSent
    );
  };

  onCreditCardPay = (paymentInfo) => {
    const payload = {
      ...paymentInfo,
      card_brand: getCardFlag(paymentInfo.card_number),
    };
    return axios
      .post(
        `${API_URL}/payment-gateway/enrollment-transaction/${this.token}`,
        payload
      )
      .then((response) => {
        if (response.data.status === PAYMENT_STATUS.CREDIT_CARD_ERROR) {
          toast.error(
            `Erro:${get(
              response,
              'data.message',
              'Ocorreu um erro inesperado!'
            )}`
          );
        }

        if (response.data.status === PAYMENT_STATUS.PAYMENT_CONFIRMED) {
          toast.success('Pagamento aprovado!');
          this.componentDidMount();
        }
      })
      .catch((err) => {
        toast.error('Ocorreu um erro inesperado!');
      });
  };

  renderPaymentMethodsSection = () => {
    const {
      onboardingPaymentMethods,
      creditCardValue,
      ProofSent,
      installments,
    } = this.state;

    const showSafeToPayPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.SAFE_TO_PAY
    ).length;
    const showCreditCardPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.CREDIT_CARD
    ).length;
    const showBoletoPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.BOLETO_INSTITUTION
    ).length;

    return (
      <>
        {showSafeToPayPayment && this.renderSafeToPayPaymentSection()}
        {showBoletoPayment && this.renderBoletoPaymentSection()}
        {!ProofSent &&
          !showSafeToPayPayment &&
          this.renderComprovantePagamento()}
        {showCreditCardPayment && (
          <CreditCardPaymentForm
            onPay={this.onCreditCardPay}
            amount={creditCardValue}
            installments={installments}
          />
        )}
      </>
    );
  };

  render() {
    const { loading, status, transactionStatus } = this.state;
    const { backClick } = this.props;
    const isEnrollmentPaid = this.isEnrollmentPaid();

    return (
      <Spinner active={loading}>
        {!isEnrollmentPaid &&
          (status === ENROLLMENT_STATUS.WAITING_PAYMENT ||
            status == ENROLLMENT_STATUS.REVIEWING) &&
          this.renderPaymentMethodsSection()}
        {transactionStatus &&
          transactionStatus.id == PAYMENT_STATUS.PAYMENT_CONFIRMED && (
            <div className="row mb-3 mt-3">
              <div className="col-sm-12 mt-3">
                <label>A Inscrição já foi paga!</label>
              </div>
            </div>
          )}
        <div className="btn-actions">
          <button
            className="btn btn-black mr-2"
            type="button"
            onClick={() => backClick()}
          >
            Voltar
          </button>
        </div>
      </Spinner>
    );
  }
}

export default withRouter(Payment);
